// src/plugins/vuetify.js

import Vue from "vue";
import Vuetify, {
  VContainer,
  VRow,
  VCol
} from "vuetify/lib";

Vue.use(Vuetify, {
  components: {
    VRow,
    VContainer,
    VCol
  }
});

export default new Vuetify({});
